import { makeStyles } from 'tss-react/mui'

const useStyles = makeStyles()(() => ({
  wrapper: {
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
  },
  noActivities: {
    margin: 'auto',
  },
}))

export default useStyles
